import * as React from 'react';
import {Alert} from '@material-ui/lab';
import {Element, scroller} from "react-scroll";

interface IProps {
    purchaseId?: string;
    resultSuccessful: boolean;
}

function scrollToTopOfResults() {
    scroller.scrollTo("order-result", {
        delay: 0,
        duration: 800,
        offset: -250,
        smooth: "easeInOutQuart",
    });
}

class OrderResult extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <div>
                <br/>
                <div style={{
                    border: '3px solid lightgray',
                    padding: '5px',
                    whiteSpace: "pre-wrap",
                    wordBreak: "normal",
                    wordWrap: "break-word"
                }}>

                    {this.props.resultSuccessful &&
                        <Alert variant="filled" severity="info">
                            Order created successfully with purchase id: '{this.props.purchaseId}'
                        </Alert>}

                    {this.props.resultSuccessful && scrollToTopOfResults()}

                    <Element name="order-result"/>
                </div>
            </div>
        );
    }
}

export default OrderResult;
